// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"12":"profiler","9777":"recorder"}[chunkId] || chunkId) + "." + {"12":"ee90ae5a8327daf0","2927":"e8319a947c61a228","4417":"8ca19c96547d860a","8974":"b7144c56b6fe2652","9777":"ed2fe4b1fe6dee03"}[chunkId] + ".js";
};